import React, { ReactNode } from 'react';
import classNames from 'classnames/bind';

import styles from './index.module.pcss';

interface DividerProps {
  className?: string;
  fleek?: boolean;
}

const cx = classNames.bind(styles);
const Divider = ({ className, fleek }: DividerProps): JSX.Element => {
  return <div className={cx('divider', className, { 'fleek-divider' : fleek })} />;
};

Divider.defaultProps = {
  className: '',
  fleek:false
};

export default Divider;
